import { Pipe, PipeTransform } from '@angular/core';
import { isNil } from 'lodash';

@Pipe({
  name: 'isNil',
  standalone: true,
})
export class IsNilPipe implements PipeTransform {
  transform(value: unknown): value is null | undefined {
    return isNil(value);
  }
}
